import { render, staticRenderFns } from "./ApplicationNotes.vue?vue&type=template&id=3be9c312"
import script from "./ApplicationNotes.vue?vue&type=script&lang=js"
export * from "./ApplicationNotes.vue?vue&type=script&lang=js"
import style0 from "./ApplicationNotes.vue?vue&type=style&index=0&id=3be9c312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports